/**
 * Coalesces parallel identical async work: multiple callers while one request is
 * in flight share a single Promise.
 * For idempotent GET-like reads. Avoid for unique mutating operations.
 */
const inFlight = new Map<string, Promise<unknown>>()

export function dedupeInFlight<T>(key: string, run: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key) as Promise<T> | undefined
  if (existing) {
    return existing
  }
  const p = run().finally(() => {
    inFlight.delete(key)
  }) as Promise<T>
  inFlight.set(key, p)
  return p
}
